import React from 'react';
import Routes from './Routes';
import log from './util/log';

// Setup analytics. Currently `storefront-analytics` does not support SSR, so check for window then lazy load the bundle
if (typeof window !== 'undefined') {
  import(/* webpackPreload: true */ '../client/analytics').then(
    ({ default: Analytics }) => {
      Analytics();
    },
    (error) => log.error('Failed to setup analytics', error),
  );
}

const App = () => <Routes />;

export default App;
